import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

interface IProps {
  withTransparentBg: boolean;
  logoSize: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
    height: '100%',
    background: (props: IProps) =>
      props.withTransparentBg ? 'transparent' : theme.palette.background.default,

    '& svg': {
      width: props => `${props.logoSize}px`,
      height: props => `${props.logoSize}px`,
      transformOrigin: '50% 50%',
    },
  },

  darkIcon: {
    '& circle': {
      stroke: 'white',
    }
  },
  title: {
    fontWeight: 'bold',
  },
  iconContainer: {
    position: 'relative',
    opacity: 1,
    '& .MuiCircularProgress-svg': {
      height: '100px',
      width: '100px',
    },
    '& .MuiCircularProgress-root': {
      minHeight: '100px',
      minWidth: '100px',
    }
  },
  wolfLogo: {
    width: '50px',
    height: '50px',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    top: '50%',
    right: 0,
  },
}));

export default useStyles;
